import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { checkoutUrl, productPrice } from '../data/bonuses';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-185" data-mp="nu9olp42ow6g">
      {visible ? <motion.div initial={{
      y: 80
    }} animate={{
      y: 0
    }} exit={{
      y: 80
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-plum/10 bg-cream/95 px-4 py-3 backdrop-blur sm:hidden" data-id="element-186" data-mp="jty2e7w2ansv">
          <a href={checkoutUrl} className="flex w-full items-center justify-center gap-2 rounded-full bg-clay px-5 py-3.5 text-sm font-medium uppercase tracking-[0.12em] text-cream active:scale-[0.98]" data-id="element-187" data-mp="298w5y01foiy6">
            Quiero mi eBook — {productPrice}
          </a>
          <p className="mt-2 text-center text-[0.7rem] text-ink/55" data-id="element-188" data-mp="3mgu7e80eyqg5">
            + 6 bonos gratis · Descarga inmediata
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}